/**
 * A models class that serves as a base models for other models classes with predefined methods.
 */
export abstract class BaseModel<T> {
  id?: T;
}
